// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/** Fleche gauche PLEINE (fut + tete), d'un seul trace. Source `left.svg`. */
export const IconLeft = createCustomIcon(
  'IconLeft',
  '0 0 234.17 234.38',
  <polygon
    fill="currentColor"
    points="234.17 129.89 49.57 130.05 135.51 216.19 117.14 234.38 0 117.24 117.14 0 135.45 18.29 49.69 104.17 234.13 104.26 234.17 129.89"
  />,
);
